import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./partials/Svg";
import { fetchPublishedBlogs } from "./partials/BlogView";
import PastBlogsModal from "./partials/PastBlogsModal";
// import { FaUserCircle } from "react-icons/fa"; // Import Font Awesome user icon

function Header() {
  const [showPostsModal, setShowPostsModal] = useState(false);
  const [sortedBlogs, setSortedBlogs] = useState(null);

  useEffect(() => {
    if (!showPostsModal || sortedBlogs !== null) return;
    let cancelled = false;
    (async () => {
      try {
        const list = await fetchPublishedBlogs();
        if (!cancelled) setSortedBlogs(list);
      } catch (e) {
        console.error(e);
        if (!cancelled) setSortedBlogs([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showPostsModal, sortedBlogs]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <Logo style={{ width: "70%", height: "50%" }} />
          </Link>

          {/* Navbar Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Content */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  data-testid="HomeBtn"
                  aria-current="page"
                  to="/"
                >
                  <button type="button" className="btn btn-outline-primary">
                    <strong> Home </strong>
                  </button>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  data-testid="AboutUsBtn"
                  to="/aboutus"
                >
                  <button type="button" className="btn btn-outline-primary">
                    <strong> About Us </strong>
                  </button>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  data-testid="ourServ"
                  to="/ourservices"
                >
                  <button type="button" className="btn btn-outline-primary">
                    <strong> Our Services </strong>
                  </button>
                </Link>
              </li>
              <li className="nav-item">
                <span className="nav-link" style={{ cursor: "pointer" }}>
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    data-testid="viewPostsBtn"
                    onClick={() => setShowPostsModal(true)}
                  >
                    <strong> View Posts </strong>
                  </button>
                </span>
              </li>
            </ul>
            <ul className="navbar-nav  mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  data-testid="contactBtn"
                  to="/contactpage"
                >
                  <button type="button" className="btn btn-outline-primary">
                    <strong> Contact Us </strong>
                  </button>
                </Link>
              </li>
              <li className="nav-item">
                {/* Profile Icon */}
                {/* <Link
                  to="/myaccount"
                   className="nav-link"
                  style={{
                    textDecoration: "none",
                  }}
                >
              
                  <button type="button" className="btn btn-outline-primary">
                    <FaUserCircle
                    size={22}
                    // style={{
                    //   marginLeft: "8px",
                    // }}
                  />
                  </button>
                
                </Link> */}
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <PastBlogsModal
        show={showPostsModal}
        onHide={() => setShowPostsModal(false)}
        loading={showPostsModal && sortedBlogs === null}
        blogs={sortedBlogs ?? []}
      />
    </div>
  );
}

export default Header;
